import React from "react"
import PropTypes from "prop-types"
import { Link, BrowserRouter as Router } from "react-router-dom"
import { getPersonDepartmentName } from "../utils"

// Helper functions

const roundedScore = value => {
  return value ? Math.round(value) : null
}

const TopTeams = props => {
  const { data } = props

  const getLink = (i, department) => {
    return `/engagement/vision2/insights/department/${department.elevate_person_id}`
  }

  return data ? (
    <div>
      {data.map((department, i) => (
        <div
          key={`row-${department.elevate_person_id}`}
          className="top-teams-row d-flex py-0 align-items-center"
        >
          <div className="top-circle text-align-center">{i + 1}</div>
          <Router>
            <Link style={{ width: "70%" }} to={getLink(i, department)}>
              <div className="text-truncate py-1">
                {getPersonDepartmentName(
                  department.department,
                  department.employee_first_name,
                  department.employee_last_name
                )}
              </div>
            </Link>
          </Router>
          <div className="top-score body-2-reg">
            {roundedScore(department.riskScore)}
          </div>
        </div>
      ))}
    </div>
  ) : null
}

export default TopTeams

TopTeams.propTypes = {
  data: PropTypes.arrayOf(
    PropTypes.shape({
      riskScore: PropTypes.number,
      elevate_person_id: PropTypes.string,
      department: PropTypes.string,
      employee_first_name: PropTypes.string,
      employee_last_name: PropTypes.string
    })
  )
}

TopTeams.defaultProps = {
  data: [
    {
      riskScore: null,
      elevate_person_id: "1",
      department: "Default"
    }
  ]
}
